import axiosCall from './interceptor';
import URL from '../helper';

export const getDownloadLinks = async (batchId) => {
  const url = `${URL.BATCH_SYSTEM_URL}download?batchId=${batchId}`;
  let response = await axiosCall('post', url, {});
  return response.data;
};